import { useEffect, useState } from "react";
import { Lightbulb } from "lucide-react";
import { api } from "../lib/api";
import { AskMari } from "./dashboard/MetricTip";

export const ExplainPanel = ({ disputeId }) => {
  const [x, setX] = useState(null);
  useEffect(() => { api.get(`/disputes/${disputeId}/explain`).then((r) => setX(r.data)); }, [disputeId]);
  if (!x) return null;
  return (
    <div className="space-y-4" data-testid="explain-panel">
      <div>
        <p className="label-xs">Evidence strength · <span className="text-white" data-testid="explain-strength">{x.strength}%</span></p>
        {x.missing.length ? (
          <ul className="mt-2 space-y-1.5" data-testid="explain-missing">
            {x.missing.map((m) => <li key={m.type} className="text-sm text-[#FFB800] flex gap-2"><Lightbulb className="w-4 h-4 shrink-0 mt-0.5" />{m.tip}</li>)}
          </ul>
        ) : <p className="text-sm text-brand mt-2">Nothing missing. Every evidence type this reason code needs is present.</p>}
        {x.present.length > 0 && <p className="text-xs text-white/45 mt-2">You have: {x.present.join(", ")}.</p>}
      </div>
      <div>
        <p className="label-xs">Win probability · <span className="text-white" data-testid="explain-win">{x.predicted_win}%</span></p>
        <ul className="mt-2 text-sm text-white/70 space-y-1" data-testid="explain-factors">
          {x.signals.map((s) => <li key={s}>✓ {s}</li>)}
          {x.bank.win_rate != null && <li>✓ {x.bank.name} reverses {x.bank.win_rate}% of resolved disputes like this</li>}
          <li className="text-white/50">{x.rationale}</li>
        </ul>
      </div>
      <AskMari q={`Explain dispute ${disputeId}: why is evidence strength ${x.strength}% and win probability ${x.predicted_win}%, and what should I add?`} testid="explain-ask-mari" />
    </div>
  );
};
